var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenuArrow = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons"
}, /*#__PURE__*/React.createElement("path", {
  id: "\xF0\x9F\x8E\xA8  Icon Color",
  d: "M6 18H21C21.55 18 22 17.55 22 17C22 16.45 21.55 16 21 16H6C5.45 16 5 16.45 5 17C5 17.55 5.45 18 6 18ZM6 13H21C21.55 13 22 12.55 22 12C22 11.45 21.55 11 21 11H6C5.45 11 5 11.45 5 12C5 12.55 5.45 13 6 13ZM11 7C11 7.55 11.45 8 12 8H21C21.55 8 22 7.55 22 7C22 6.45 21.55 6 21 6H12C11.45 6 11 6.45 11 7Z",
  fill: "#FF8B22"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector",
  d: "M8.93135 6.61229C9.04733 6.72924 9.04733 6.91782 8.93135 7.03477L6.41302 9.57427C6.29566 9.69261 6.10434 9.69261 5.98698 9.57427L5.60618 9.19026C5.49009 9.0732 5.49022 8.88439 5.60647 8.76748L6.80263 7.56463C6.86536 7.50156 6.82068 7.39412 6.73172 7.39412L3.13333 7.39412C3.0781 7.39412 3.03333 7.43889 3.03333 7.49412L3.03333 17.8C3.03333 17.9657 2.89902 18.1 2.73333 18.1L2.2 18.1C2.03431 18.1 1.9 17.9657 1.9 17.8L1.9 6.55294C1.9 6.38726 2.03431 6.25294 2.2 6.25294L6.73172 6.25294C6.82068 6.25294 6.86535 6.14551 6.80263 6.08243L5.60647 4.87958C5.49022 4.76267 5.49008 4.57386 5.60618 4.4568L5.98698 4.07279C6.10434 3.95445 6.29566 3.95445 6.41302 4.07279L8.93135 6.61229Z",
  fill: "#FF8B22",
  stroke: "#FF8B22",
  strokeWidth: 0.2
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenuArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu-arrow.f077a7b48375945c099d5b2b929abe18.svg";